import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { Filter, FilterOperation } from "src/app/core/jsonapi/filter";
import { FilterBuilder } from "src/app/core/jsonapi/filters-builder";
import { IParamsCollection } from "src/app/core/jsonapi/interfaces/params-collection";
import { CasesServicesService } from "src/app/modules/cases/_services/cases-services.service";
import { CasesService } from "src/app/modules/cases/_services/cases.service";
import { Case } from "src/app/modules/cases/_types/case";
import { CaseService } from "src/app/modules/cases/_types/case-service";
import { SurveysAnswersService } from "src/app/modules/surveys/_services/surveys-answers.service";
import { SurveysQuestionAnswersService } from "src/app/modules/surveys/_services/surveys-questions-answers.service";
import { SurveysQuestionsOptionsService } from "src/app/modules/surveys/_services/surveys-questions-options.service";
import { SurveysQuestionsService } from "src/app/modules/surveys/_services/surveys-questions.service";
import { SurveysService } from "src/app/modules/surveys/_services/surveys.service";
import { Survey } from "src/app/modules/surveys/_types/survey";
import { SurveyAnswer } from "src/app/modules/surveys/_types/survey-answer";
import { SurveyQuestionAnswer } from "src/app/modules/surveys/_types/survey-question-answer";

@Component({
    selector: 'app-public-survey-response',
    templateUrl: './public-survey-response.component.html',
    styleUrls: ['./public-survey-response.component.scss'],
    standalone: false
})
export class PublicSurveyResponseComponent {

    //id de la encuesta
    public surveyId: string | null;
    //id de la entidad que esta respondiendo la encuesta (ejemplo el usuario id)
    public sourceId: string | null;
    //tipo de entidad que esta respondiendo la encuesta
    public sourceType: string | null;
    //id de la entidad a la que se le esta respondiendo la encuesta
    public targetId: string | null;
    //tipo de entidad a la que se le esta respondiendo la encuesta
    public targetType: string | null;

    public scale5Options: any[] = [
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' },
        { label: '5', value: '5' }
    ];

    public survey: Survey = new Survey();
    public questions: any[] = []

    constructor(
        private surveysService: SurveysService,
        private surveysQuestionsService: SurveysQuestionsService,
        private surveysAnswersService: SurveysAnswersService,
        private surveysQuestionsAnswersService: SurveysQuestionAnswersService,
        private surveysQuestionsOptionsService: SurveysQuestionsOptionsService,
        private route: ActivatedRoute,
        private router: Router,
        private caseService: CasesService,
        private caseServiceService: CasesServicesService
    ) {

        //url de entrada de ejemplo para encuesta de satisfaccion de servicio 379e04a5-9189-4992-af44-856ca337dfdc que responde el cliente fdb73a9d-7c13-492b-cd71-08dc9f444441
        //http://localhost:4200/public/surveys/dc3e7d85-856c-4849-8ba4-08dce86bd009/caseservice/379e04a5-9189-4992-af44-856ca337dfdc/client/fdb73a9d-7c13-492b-cd71-08dc9f444441


        this.surveyId = route.snapshot.paramMap.get('surveyId');
        this.targetType = route.snapshot.paramMap.get('targetType');
        this.targetId = route.snapshot.paramMap.get('targetId');
        this.sourceType = route.snapshot.paramMap.get('sourceType');
        this.sourceId = route.snapshot.paramMap.get('sourceId');

        //cargar encuesta de api
        this.loadSurvey();

        //cargar preguntas de encuesta de api
        this.loadSurveyQuestions();
    }

    async loadSurvey() {
        this.survey = await firstValueFrom(this.surveysService.get(this.surveyId as string, {include:['userType']}));
        this.loadSurveyInfo();
    }

    async loadSurveyInfo(){
        if(this.sourceType == null){
            this.sourceType = this.survey.targetType;
            //obtenemos el sourceId de la encuesta
            //console.log("userTypeId", this.survey.userTypeId, "targetType", this.targetType, "sourceType", this.sourceType, "targetId", this.targetId, "this.survey.userType", this.survey.userType);

            if(this.survey.userTypeId != null)
            {
                let caseService = new CaseService();
                let case_ = new Case();
                //comprobamos si es un case service o un case
                if(this.targetType == "caseservice"){
                    caseService = await firstValueFrom(this.caseServiceService.get(this.targetId as string, {include:['case']}));
                } else {
                    case_ = await firstValueFrom(this.caseService.get(this.targetId as string));
                }


                if(this.survey.userType?.code == "processor"){
                    //buscamos el tramitador del case_service
                    this.sourceId = (caseService!=null?caseService.case?.processorId:null) as string;

                }else if(this.survey.userType?.code == "worker"){                   

                    this.sourceId = (caseService!=null?caseService.workerId :null) as string;
                }
            }else{
                //si no tiene userTypeId, es porque es al cliente. Lo obtenemos del case_service.
                let caseService = await firstValueFrom(this.caseServiceService.get(this.targetId as string, {include:['case']}));
                this.sourceId = (caseService!=null?caseService.clientId :null) as string;
            }
        }
    }

    async loadSurveyQuestions() {
        let params: IParamsCollection = {}

        let filters: any = {
            surveyId: new Filter(FilterOperation.equals, "surveyId"),
        };

        filters.surveyId.value = this.surveyId;
        params.filter = FilterBuilder.fromObject(filters).build();


        let response = await firstValueFrom(this.surveysQuestionsService.all(params));
        this.questions = response.data;

        this.questions.forEach((question: any) => {
            if (question.surveyQuestionType == 'Options' || question.surveyQuestionType == 'Multiple') {
                this.addOptionsToQuestion(question);
            }
        });
    }

    async loadSurveyQuestionOptions(questionId: string) {
        let params: IParamsCollection = {}

        let filters: any = {
            surveyQuestionId: new Filter(FilterOperation.equals, "surveyQuestionId"),
        };

        filters.surveyQuestionId.value = questionId;
        params.filter = FilterBuilder.fromObject(filters).build();

        let response = await firstValueFrom(this.surveysQuestionsOptionsService.all(params));
        return response.data;
    }

    addOptionsToQuestion(question: any) {
        this.loadSurveyQuestionOptions(question.id).then((options) => {
            question.options = options;
        });
    }

    async sendResponse() {
        //TODO: guardar SurveyAnswer y SurveyAnswerQuestion
        let surveyAnswer = await this.saveSurveyAnswer();

        try {
            for (let question of this.questions) {
                await this.saveSurveyQuestionAnswer(question, surveyAnswer);
            }
        } catch (error) {
            console.error(error);
        }

        //si todo ok, redirigir a pagina de agradecimiento
        this.router.navigate(['/public/surveys/thanks']);
    }

    async saveSurveyAnswer() {
        let surveyAnswer = new SurveyAnswer();

        surveyAnswer.surveyId = this.surveyId as string;
        surveyAnswer.sourceType = this.sourceType as string;
        surveyAnswer.sourceId = this.sourceId as string;
        surveyAnswer.targetType =  this.targetType as string;
        surveyAnswer.targetId = this.targetId as string;
        surveyAnswer.date = new Date();
        console.log(surveyAnswer);

        let response = await firstValueFrom(this.surveysAnswersService.save(surveyAnswer));
        return response;
    }

    async saveSurveyQuestionAnswer(question: any, answer: any) {
        let surveyQuestionAnswer = new SurveyQuestionAnswer();

        surveyQuestionAnswer.surveyAnswerId = answer.id;
        surveyQuestionAnswer.surveyQuestionId = question.id;
        surveyQuestionAnswer.answer = question.answer;
        if(Array.isArray(question.answer)){
            surveyQuestionAnswer.answer = question.answer.join(',');
        }
        let response = await firstValueFrom(this.surveysQuestionsAnswersService.save(surveyQuestionAnswer));
    }

    showQuestion(question: any){
        if(question.showIf){
            //Tenemos que evaluar la condicion de la pregunta
            let questionCondition = this.questions.find((q: any) => q.id == question.surveyIfQuestionId);

            if(questionCondition!=null && questionCondition.answer!=null && questionCondition.answer == question.surveyIfQuestionCondition){
                return true;
            }else{
                return false;
            }
            return true;
        }else{
            return true;
        }
    }
}